export const isCustomShipper = (shipper: string): boolean =>
    ['CUSTOM', 'CUSTOM PARCEL', 'CUSTOM PALLET', 'VLASTNI', 'VLASTNǏ'].includes(shipper.toUpperCase());
